webpackJsonp([35783957827783],{

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactAnchorLinkSmoothScroll = __webpack_require__(24);
	
	var _reactAnchorLinkSmoothScroll2 = _interopRequireDefault(_reactAnchorLinkSmoothScroll);
	
	var _gatsbyImage = __webpack_require__(155);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(34);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _AboutUsComponent = __webpack_require__(63);
	
	var _AboutUsComponent2 = _interopRequireDefault(_AboutUsComponent);
	
	var _ContactComponent = __webpack_require__(39);
	
	var _ContactComponent2 = _interopRequireDefault(_ContactComponent);
	
	var _CtaComponent = __webpack_require__(40);
	
	var _CtaComponent2 = _interopRequireDefault(_CtaComponent);
	
	var _LeadComponent = __webpack_require__(35);
	
	var _LeadComponent2 = _interopRequireDefault(_LeadComponent);
	
	var _LeadComponentServices = __webpack_require__(41);
	
	var _LeadComponentServices2 = _interopRequireDefault(_LeadComponentServices);
	
	var _SeoComponent = __webpack_require__(42);
	
	var _SeoComponent2 = _interopRequireDefault(_SeoComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ThePage = function (_React$Component) {
	  _inherits(ThePage, _React$Component);
	
	  function ThePage() {
	    _classCallCheck(this, ThePage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ThePage.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_SeoComponent2.default, {
	        title: 'Softwarepiloten - Agentur f\xFCr Meteor.js-Programmierung',
	        description: 'Wir planen, designen, programmieren, testen, deployen und messen Ihre Webapplikation oder Mobile-App. In Full-Stack JavaScript undMeteor.Js. Interesse? Dann kontaktieren Sie uns jetzt'
	      }),
	      _react2.default.createElement(_LeadComponent2.default, {
	        leadText: 'WIR ENTWICKELN MIT VIEL LIEBE <i class="fas fa-heart"></i><br/>IHRE SOFTWARE.',
	        subText: 'Wir planen, designen, programmieren, testen, deployen und messen Ihre Webapplikation oder Mobile-App. In <b>Full-Stack JavaScript</b> und Meteor.Js.<br/><br/><b>Ben\xF6tigen Sie aktuell Unterst\xFCtzung?</b> Dann schreiben Sie uns doch einfach. Wir beraten Sie gerne unverbindlich und freuen uns auf Sie\u2026'
	      }),
	      _react2.default.createElement(_LeadComponentServices2.default, { imageStore: this.props.imageStore }),
	      _react2.default.createElement(_AboutUsComponent2.default, { imageStore: this.props.imageStore }),
	      _react2.default.createElement(_CtaComponent2.default, null),
	      _react2.default.createElement(
	        'div',
	        { id: 'fh5co-about-us' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row', id: 'about-us' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 section-heading text-center' },
	              _react2.default.createElement(
	                'h2',
	                { className: '' },
	                'GEMEINSAM ZUM ERFOLG'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-6 col-md-offset-3' },
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Von der Konzeption, bis hin zur Full-Stack Programmierung (inklusive automatisierter Tests) und konstanten Analyse des Benutzer-Verhaltens: Mit uns wird Ihr Projekt ein Erfolg.'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: this.props.imageStore.meteorJsWebapplikationImage.sizes, alt: 'Meteor js Webapplikation' })
	      ),
	      _react2.default.createElement(_ContactComponent2.default, null)
	    );
	  };
	
	  return ThePage;
	}(_react2.default.Component);
	
	exports.default = ThePage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-d158a290a2ef14a827ad.js